module.exports = __webpack_public_path__ + "img/sizenotfound_animation_loop.gif";